
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesDevicePathTreeNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreeNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesDevicePathTree"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreeNodeCollection"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesDevicePathTreeNode"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesDeviceBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComgyDevice"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesConnectedDeviceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComgyConnectedDevice"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceMount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"spot"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesDevicePathTree"},"directives":[]}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesDeviceBaseFragment"},"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesConnectableDeviceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComgyConnectableDevice"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intendedRole"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesDeviceBaseFragment"},"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesUnconnectableDeviceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComgyUnconnectableDevice"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesDeviceBaseFragment"},"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesDeviceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComgyDevice"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesConnectedDeviceFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesConnectableDeviceFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppCustomerComgyApiConnectDevicesUnconnectableDeviceFragment"},"directives":[]}]}}],"loc":{"start":0,"end":1340}};
    doc.loc.source = {"body":"fragment AppCustomerComgyApiConnectDevicesDevicePathTreeNode on TreeNode {\n  __typename\n  id\n  name\n}\n\nfragment AppCustomerComgyApiConnectDevicesDevicePathTree on TreeNodeCollection {\n  items {\n    ...AppCustomerComgyApiConnectDevicesDevicePathTreeNode\n  }\n}\n\nfragment AppCustomerComgyApiConnectDevicesDeviceBaseFragment on ComgyDevice {\n  __typename\n  id\n  type\n  details\n}\n\nfragment AppCustomerComgyApiConnectDevicesConnectedDeviceFragment on ComgyConnectedDevice {\n  deviceMount {\n    id\n    spot {\n      id\n      role\n      path {\n        ...AppCustomerComgyApiConnectDevicesDevicePathTree\n      }\n    }\n  }\n  ...AppCustomerComgyApiConnectDevicesDeviceBaseFragment\n}\nfragment AppCustomerComgyApiConnectDevicesConnectableDeviceFragment on ComgyConnectableDevice {\n  intendedRole\n  ...AppCustomerComgyApiConnectDevicesDeviceBaseFragment\n}\nfragment AppCustomerComgyApiConnectDevicesUnconnectableDeviceFragment on ComgyUnconnectableDevice {\n  ...AppCustomerComgyApiConnectDevicesDeviceBaseFragment\n}\n\n# this fragment can be used in the queries, instead of repeating stuff\nfragment AppCustomerComgyApiConnectDevicesDeviceFragment on ComgyDevice {\n  ...AppCustomerComgyApiConnectDevicesConnectedDeviceFragment\n  ...AppCustomerComgyApiConnectDevicesConnectableDeviceFragment\n  ...AppCustomerComgyApiConnectDevicesUnconnectableDeviceFragment\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AppCustomerComgyApiConnectDevicesDevicePathTreeNode"] = oneQuery(doc, "AppCustomerComgyApiConnectDevicesDevicePathTreeNode");
        
        module.exports["AppCustomerComgyApiConnectDevicesDevicePathTree"] = oneQuery(doc, "AppCustomerComgyApiConnectDevicesDevicePathTree");
        
        module.exports["AppCustomerComgyApiConnectDevicesDeviceBaseFragment"] = oneQuery(doc, "AppCustomerComgyApiConnectDevicesDeviceBaseFragment");
        
        module.exports["AppCustomerComgyApiConnectDevicesConnectedDeviceFragment"] = oneQuery(doc, "AppCustomerComgyApiConnectDevicesConnectedDeviceFragment");
        
        module.exports["AppCustomerComgyApiConnectDevicesConnectableDeviceFragment"] = oneQuery(doc, "AppCustomerComgyApiConnectDevicesConnectableDeviceFragment");
        
        module.exports["AppCustomerComgyApiConnectDevicesUnconnectableDeviceFragment"] = oneQuery(doc, "AppCustomerComgyApiConnectDevicesUnconnectableDeviceFragment");
        
        module.exports["AppCustomerComgyApiConnectDevicesDeviceFragment"] = oneQuery(doc, "AppCustomerComgyApiConnectDevicesDeviceFragment");
        
